/**
 * Emails allowed to see the Admin entry point and open the Admin dashboard.
 * NOTE: this gates the UI only — the /admin/* API must enforce access server-side.
 */
const ADMIN_EMAILS = new Set<string>([
  "moshe@echotora.com",
  "moshe157@gmail.com",
  "mmoshe157@gmail.com",
  "moshem@google.com",
  "avishitrit@google.com",
  "avi.shitri@gmail.com",
  "avi.shitrit@gmail.com",
]);

export function isAdminEmail(email: string | null | undefined): boolean {
  return Boolean(email && ADMIN_EMAILS.has(email.trim().toLowerCase()));
}

export const SUPER_ADMIN_EMAILS = new Set<string>([
  "moshe@echotora.com",
  "moshe157@gmail.com",
  "mmoshe157@gmail.com",
  "moshem@google.com",
  "avishitrit@google.com",
  "avi.shitri@gmail.com",
  "avi.shitrit@gmail.com",
]);

export function isSuperAdminEmail(email: string | null | undefined): boolean {
  return Boolean(email && SUPER_ADMIN_EMAILS.has(email.trim().toLowerCase()));
}
